export const htmlToPlainText = (html: string): string => {
    return html
        .replace(/<li>/gi, "• ")
        .replace(/<\/li>/gi, "\n")
        .replace(/<[^>]*>/g, "")
        .trim();
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
        }
        return true;
    } catch (err) {
        console.error("Failed to copy text: ", err);
        return false;
    }
};

export const copyInsightsToClipboard = async (htmlInsights: string): Promise<boolean> => {
    const plainText = htmlToPlainText(htmlInsights);
    return copyToClipboard(plainText);
};
